import { z } from 'zod'
import {
  CofidisContractType,
  CofidisEditionMode,
  CofidisFamilySituation,
  CofidisHomeType,
  CofidisIdType,
  CofidisOptInFlag,
  CofidisSalaryMonthsNumber,
  CofidisSustainableSupport,
  CofidisTitleCode,
  CofidisWayType,
} from './enums'
import { CofidisMonthlyApplicationSchema } from './schema'

export type {
  CofidisContractType,
  CofidisEditionMode,
  CofidisFamilySituation,
  CofidisHomeType,
  CofidisIdType,
  CofidisOptInFlag,
  CofidisSalaryMonthsNumber,
  CofidisSustainableSupport,
  CofidisTitleCode,
  CofidisWayType,
}

export type CofidisMonthlyApplicationValues = z.infer<
  typeof CofidisMonthlyApplicationSchema
>

export type CofidisMonthlyApplicationFormValues =
  Partial<CofidisMonthlyApplicationValues>

export type CofidisSectionFieldSuccess = Partial<
  Record<keyof CofidisMonthlyApplicationFormValues, boolean>
>

export type CofidisSectionProps = {
  fieldSuccess?: CofidisSectionFieldSuccess
}

export type CofidisMonthlyApplicationPayload = Omit<
  CofidisMonthlyApplicationValues,
  | 'vedaconAcceptance'
  | 'internalOptin'
  | 'partnerOptin'
  | 'idCessationOfValidityDate'
  | 'birthDate'
  | 'entranceDate'
  | 'bankAccountOpeningDate'
  | 'contractStartDate'
  | 'contractEndDate'
> & {
  vedaconAcceptance: CofidisOptInFlag
  internalOptin?: CofidisOptInFlag
  partnerOptin?: CofidisOptInFlag
  idCessationOfValidityDate: string
  birthDate: string
  entranceDate: string
  bankAccountOpeningDate?: string
  contractStartDate?: string
  contractEndDate?: string
}
